import React, {useCallback, useEffect, useRef} from 'react';
import styles from './NavMenu.module.scss'
import {buttonClick} from "utils/Helpers";

const NavMenu = (props) => {

    const date = new Date();
    const year = date.getFullYear();
    const menu = useRef();

    const handleClickOutside = useCallback((event)=>{
        if (menu.current && !menu.current.contains(event.target) && !props.toggle.contains(event.target)) {
            props.close()
        }
    },[props]);
    
    function followLink(location){
        props.linkTo(location);
        props.close();
    }

    useEffect(()=>{
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [handleClickOutside])

    return (
        <div ref={menu} className={styles.navMenu}>
            <ul className={styles.main}>

                <li tabIndex={0} role={'link'} aria-label={'Navigate to Home'} onKeyDown={buttonClick} className={styles.link} onClick={()=>followLink('introText')}>Home</li>
                <li tabIndex={0} role={'link'} aria-label={'Navigate to Surface Originals'} onKeyDown={buttonClick} className={styles.link} onClick={()=>followLink('contest')}>Originals Contest Winners</li>
                <li>Meet our Originals</li>
                <li>
                    <ul className={styles.sub}>
                        <li tabIndex={0} role={'link'} aria-label={'Navigate to Martellus Bennett'} onKeyDown={buttonClick} className={styles.link} onClick={()=>followLink('martellus')}>Martellus Bennett</li>
                        <li tabIndex={0} role={'link'} aria-label={'Navigate to deadmau5'} onKeyDown={buttonClick} className={styles.link} onClick={()=>followLink('deadmau5')}>deadmau5</li>
                        <li tabIndex={0} role={'link'} aria-label={'Navigate to Cache Bunny'} onKeyDown={buttonClick} className={styles.link} onClick={()=>followLink('cache')}>Cache Bunny</li>
                        <li tabIndex={0} role={'link'} aria-label={'Navigate to Brooke Shaden'} onKeyDown={buttonClick} className={styles.link} onClick={()=>followLink('brooke')}>Brooke Shaden</li>
                        <li tabIndex={0} role={'link'} aria-label={'Navigate to Originals Spotlight'} onKeyDown={buttonClick} className={styles.link} onClick={()=>followLink('spotlight')}>Originals Spotlight</li>
                    </ul>
                </li>
                {/*<li tabIndex={0} role={'link'} aria-label={'Navigate to Project Inspire'} onKeyDown={buttonClick} className={styles.link} onClick={()=>followLink('project-inspire')}>Project Inspire</li>*/}
                <li tabIndex={0} role={'link'} aria-label={'Navigate to Redisign your Surface'} onKeyDown={buttonClick} className={styles.link} onClick={()=>followLink('customize-yours')}>Redesign your Surface</li>
                <li><a href={'http://www.surface.com'} target={'_blank'} rel={'noreferrer'}>Surface.com</a> <img aria-hidden={true} src={'https://msobd-storage.azureedge.net/images/external-icon.png'} alt={'External link'}/></li>

            </ul>
            <div className={styles.privacy}>
                <div><a href={'https://go.microsoft.com/fwlink/?LinkId=521839 '} target={'_blank'} rel={'noreferrer'}>Privacy Statement</a> <img aria-hidden={true} src={'https://msobd-storage.azureedge.net/images/external-icon.png'} alt={'External link'}/></div>
                <div>&copy; Microsoft {year}</div>
            </div>
        </div>
    )
};

export default NavMenu
